import { AllMerchantsPageContent } from "Components/Hunter/AllMerchants/AllMerchantsPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Pages.Titles;

export const AllMerchantsPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(RESOURCES.AllMerchants)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
    >
      <StyledPageWrapper maxWidth="unset !important">
        <AllMerchantsPageContent />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default AllMerchantsPage;
